import { render, staticRenderFns } from "./SessionExpiredError.vue?vue&type=template&id=342d303e&"
import script from "./SessionExpiredError.vue?vue&type=script&lang=ts&"
export * from "./SessionExpiredError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports